import React, { Component } from 'react';
import moment from 'moment';
import { LeftOutlined } from '@ant-design/icons';
import { Button, Typography, Spin } from 'antd';

import Error from '../../components/Error/Error';
import Loading from '../../components/Loading/Loading';
import KeyInvalid from '../../components/KeyInvalid/KeyInvalid';
import SiteAnalytics from '../../components/SiteAnalytics/SiteAnalytics';
import ReportPage from '../Report/ReportPage';
import Onboarding from './Onboarding';
import JobPicker from './JobPicker';

import { useState } from '../../state/StateProvider';

const { Title } = Typography;

const OverviewPage = (props) => {
    const {
        apiKey,
        state, 
        fetch, 
        resetApiKey,
        saveApiKey,
        setSelectedJobId, 
    } = useState();

    const { 
        selectedJobId, 
        analytics, analyticsLoading, analyticsError, 
        site, siteLoading, siteError, 
        jobs, jobsLoading, jobsError,
        user, userLoading, userError,
        refreshDataLoading, refreshDataError,
        apiKeyValid, saveApiKeyLoading, saveApiKeyError,
        failedFetch,
    } = state;

    const isLoading = analyticsLoading || siteLoading || jobsLoading || userLoading || refreshDataLoading || saveApiKeyLoading;
    const isError = analyticsError || siteError || jobsError || userError || refreshDataError || saveApiKeyError || failedFetch;

    const onOpenReport = async selectedJobId => {
        setSelectedJobId(selectedJobId);
    }

    const openSiteSettings = () => {
        const { site } = state;
        if (!site || !site.siteId ) return null;
        return window.open(`https://app.amzwatcher.com/app/site/${site.siteId}`, '_blank');
    }

    const openDashboard = () => {
        const { site } = state;
        if (!site || !site.siteId ) return null;
        return window.open(`https://app.amzwatcher.com/app/dashboard`, '_blank');
    }

    if (!apiKey) return <Onboarding saveApiKey={saveApiKey} loading={saveApiKeyLoading} />;
    if (!apiKeyValid) return <KeyInvalid resetApiKey={resetApiKey} />;

    if (isLoading) return (
        <>
            <Title style={{ textAlign: 'left', margin: '10px 0 10px 0' }} level={3}>
                Broken Links Report
            </Title>
            <Loading />
        </>
    )
    if (isError) return (
        <>
            <Title style={{ textAlign: 'left', margin: '10px 0 10px 0' }} level={3}>
                Broken Links Report
            </Title>
            <Error refresh={fetch} />
        </>
    )    

    if (selectedJobId) return <ReportPage />

    return (
        <>
            <Title style={{ textAlign: 'left', margin: '10px 0 10px 0' }} level={3}>
                Broken Links Report for {site.siteUrl}
            </Title>
            <Button size="small" onClick={fetch} style={{ marginRight: 10 }}>Refresh</Button>
            {/* <Button size="small" onClick={openSiteSettings} style={{ marginRight: 10 }}>Site Settings <span aria-hidden="true" className="dashicons dashicons-external" style={{ fontSize: 15, lineHeight: '22px' }}></span></Button> */}
            <Button size="small" onClick={openDashboard}>Go To App Dashboard <span aria-hidden="true" className="dashicons dashicons-external" style={{ fontSize: 15, lineHeight: '22px' }}></span></Button>
            <SiteAnalytics 
                analytics={analytics[site.lastCompletedJobId]} 
                site={site} 
                job={jobs[site.lastCompletedJobId]} 
                loading={analyticsLoading}
                isLatest 
            />
            <JobPicker 
                analytics={analytics} 
                jobs={jobs}
                onOpenReport={onOpenReport}
                loading={jobsLoading}
            />
        </>
    )
}

export default OverviewPage;